var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowRightWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.28995 15.88L13.1699 12L9.28995 8.11999C9.19736 8.02741 9.12392 7.9175 9.07382 7.79653C9.02371 7.67557 8.99792 7.54592 8.99792 7.41499C8.99792 7.28406 9.02371 7.15441 9.07382 7.03345C9.12392 6.91248 9.19736 6.80257 9.28995 6.70999C9.38253 6.61741 9.49244 6.54397 9.6134 6.49386C9.73437 6.44376 9.86401 6.41797 9.99495 6.41797C10.1259 6.41797 10.2555 6.44376 10.3765 6.49386C10.4975 6.54397 10.6074 6.61741 10.6999 6.70999L15.2899 11.3C15.6799 11.69 15.6799 12.32 15.2899 12.71L10.6999 17.3C10.6074 17.3927 10.4975 17.4662 10.3766 17.5164C10.2556 17.5666 10.1259 17.5924 9.99495 17.5924C9.86398 17.5924 9.73429 17.5666 9.61332 17.5164C9.49235 17.4662 9.38246 17.3927 9.28995 17.3C8.90995 16.91 8.89995 16.27 9.28995 15.88Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRightWhite);
export default __webpack_public_path__ + "static/media/icon-arrow-right-white.0a13d342d0cd3a6a98cda184ecab47f1.svg";
export { ForwardRef as ReactComponent };